<template>
  <v-app>
    <v-main>
      <password-reset-dialog ref="passwordResetDialog" />
      <v-container class="inspire fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-14">
              <v-toolbar dark color="primary" class="formHeader">
                <v-toolbar-title>{{ $t('views.Login.title') }}</v-toolbar-title>
              </v-toolbar>
              <v-card-text class="formContent">
                <v-form @keydown.enter.native="login">
                  <v-text-field
                    prepend-icon="person"
                    name="email"
                    :label="$t('views.Login.email')"
                    v-model="email"
                    type="text"
                    id="email"
                    autocomplete="email"
                  />
                  <v-text-field
                    prepend-icon="lock"
                    name="password"
                    :label="$t('views.Login.password')"
                    v-model="password"
                    type="password"
                    id="password"
                    autocomplete="current-password"
                  />
                </v-form>
                <v-card-text class="errorMessage">
                  {{ errorMessage }}
                </v-card-text>
              </v-card-text>
              <v-card-actions>
                <v-btn
                  color="primary"
                  class="forgotPassword ml-1"
                  @click="passwordResetClick"
                  text
                >
                  {{
                    $t('views.Login.forgotPassword.title')
                  }}
                </v-btn>
                <v-spacer />
                <v-btn
                  color="primary"
                  class="mr-2"
                  @click="login"
                  @keydown.enter="login"
                  id="connection-btn"
                  :loading="loading"
                >
                  {{
                    $t('actions.connect')
                  }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { types } from '../store/rootTypes';
import bugsnagClient from '../bugsnag';
import PasswordResetDialog from './PasswordResetDialog';

export default {
  name: 'Login',
  components: { PasswordResetDialog },
  data() {
    return {
      email: '',
      password: '',
      errorMessage: '',
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      isAuthenticated: types.authentication.getters.isAuthenticated,
    }),
  },
  methods: {
    ...mapActions({
      signin: types.authentication.actions.signin,
      sendPasswordReset: types.authentication.actions.sendPasswordReset,
    }),
    async login() {
      this.errorMessage = '';
      this.loading = true;
      try {
        await this.signin({ email: this.email, password: this.password });
      } catch (error) {
        this.errorMessage = this.$t(`views.Login.errors.${error.code}`);
        this.loading = false;
        bugsnagClient.notify(error);
      }
    },
    async passwordResetClick() {
      this.$refs.passwordResetDialog.open();
    },
  },
  watch: {
    isAuthenticated(status) {
      if (status === true) {
        this.$router.push('/');
      }
    },
  },
};
</script>

<style scoped>
.inspire {
  position: relative;
  background-image: url('~@/assets/images/background_login.jpg');
  background-size: cover;
  background-position: center center;
}
.formContent {
  width: 90%;
}
.formHeader {
  height: 15%;
}
.errorMessage {
  color: red;
}
.forgotPassword {
  text-transform: none;
}
</style>
